module.exports = __webpack_public_path__ + "img/capacity-02.0f4733c9.png";